import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import queryString from 'query-string'
import headLogo from '../../images/headLogo.png'
import Login from './Login/index.jsx'
import Confirmation from './Confirmation/index.jsx'
import Info from './Info/index'
import CommonFetch from '../../requests/commonFetch'
import Upshot from './Upshot/index'

export default class Subscribe extends Component {
    constructor(props) {
        super(props)

        this.state = {
            subscribeType: '',
            subscribeData: {},
            subscribeInfo: {},
        }
    }

    componentDidMount() {
        this.getSubscribeInfo()
    }

    getSubscribeInfo = () => {
        let {pathname} = this.props
        let listURLParams = queryString.parse(this.props.location.search)
        let subscribeId = listURLParams.id

        CommonFetch({
            path: `ui/subscriptions/get_${pathname}?id=${subscribeId}`,
            method: 'GET',
        }).then(res => {
            let subscribeData = res.data
            let subscribeInfo = res
            delete subscribeInfo['data']

            console.log(subscribeData)
            console.log(subscribeInfo)

            this.setState({
                subscribeData,
                subscribeInfo,
            })
        })
    }

    render() {
        return (
            <div className="subscribe-wrap">
                <div className="logo">
                    <a href="https://cryptaur.com" target="_blank">
                        <img src={headLogo} />
                    </a>
                </div>
                <div className="subscribe">
                    {this.subscribeLeftBlock()}
                    {this.subscribeRightBlock()}
                </div>
            </div>
        )
    }

    subscribeLeftBlock = () => {
        let { subscribeData, subscribeInfo } = this.state

        if (
            !Object.keys(subscribeData).length ||
            !subscribeInfo.success ||
            subscribeInfo.problems.length ||
            subscribeInfo.state === 'complete'
        )
            return null

        return <Info pathname={this.props.pathname} subscribeData={subscribeData} />
    }

    subscribeRightBlock = () => {
        let { subscribeData, subscribeInfo } = this.state
        let { error, problems, depositorysubscribe_error } = subscribeInfo
        if (!Object.keys(subscribeData).length) return null

        if (error || problems.length || depositorysubscribe_error) {
            return (
                <Upshot
                    status="warning"
                    subscribeData={subscribeData}
                    subscribeInfo={subscribeInfo}
                    additionalData={{
                        desc: error
                            ? error
                            : problems.length
                            ? problems
                            : depositorysubscribe_error
                            ? depositorysubscribe_error
                            : '',
                    }}
                />
            )
        } else {
            return this.subscribeComponentSelection()
        }
    }

    subscribeComponentSelection = () => {
        let { subscribeType, subscribeData, subscribeInfo } = this.state

        switch (subscribeInfo.state) {
            case 'not_authed':
                return (
                    <Login
                        captchaKey={this.props.captchaKey}
                        switchSignIn={this.props.switchSignIn}
                        getSubscribeInfo={this.getSubscribeInfo}
                    />
                )
                break
            case 'not_set_2fa':
                return (
                    <Upshot
                        status="warning"
                        subscribeData={subscribeData}
                        subscribeInfo={subscribeInfo}
                        additionalData={{
                            desc: 'not_set_2fa',
                        }}
                    />
                )
                break
            case 'wait_agree':
                return (
                    <Confirmation
                        captchaKey={this.props.captchaKey}
                        subscribeData={subscribeData}
                        subscribeInfo={subscribeInfo}
                        subscribeState={subscribeInfo.state}
                        subscribeTFA={subscribeInfo.type_2fa}
                        getSubscribeInfo={this.getSubscribeInfo}
                        pathname={this.props.pathname}
                    />
                )
                break
            case 'wait_2fa_code':
                return (
                    <Confirmation
                        captchaKey={this.props.captchaKey}
                        subscribeData={subscribeData}
                        subscribeInfo={subscribeInfo}
                        subscribeState={subscribeInfo.state}
                        subscribeTFA={subscribeInfo.type_2fa}
                        getSubscribeInfo={this.getSubscribeInfo}
                        pathname={this.props.pathname}
                    />
                )
                break
            case 'complete':
                return (
                    <Upshot
                        status="complete"
                        subscribeData={subscribeData}
                        subscribeInfo={subscribeInfo}
                    />
                )
                break
            default:
                return (
                    <div>
                        <h1>404</h1>
                    </div>
                )
        }
    }
}
